<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19qLIsc/tc-custom/9780226519210.jpg?1724432673407" alt="This image is the cover for the book Philosophical Melancholy and Delirium"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Philosophical Melancholy and Delirium
      </h1>
      <p class="bookDescription body article font2">
        <p>The Scottish philosopher David Hume is commonly understood as the original proponent of the "end of philosophy." In this powerful new study, Donald Livingston completely revises our understanding of Hume's thought through his investigation of Hume's distinction between "true" and "false" philosophy. For Hume, false philosophy leads either to melancholy over the groundlessness of common opinion or delirium over transcending it, while true philosophy leads to wisdom. Livingston traces this distinction through all of Hume's writings, providing a systematic pathology of the corrupt philosophical consciousness in history, politics, philosophy, and literature that characterized Hume's own time as well as ours.<br/><br/> By demonstrating how a philosophical method can be used to expose the political motivations behind intellectual positions, historical events, and their subsequent interpretations, Livingston revitalizes Hume's thought and reveals its relevance for contemporary dicussions of politics, nationalism, and ideology for the first time.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Donald W. Livingston
      </h2>
      
      <p class="authorDescription body article">Please fill in author biography</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?93413076